(function () {
  function getHeaderOffset() {
    const header = document.querySelector('.site-header, header, [data-header]');
    return header ? header.getBoundingClientRect().height : 0;
  }

  function scrollToHash(hash) {
    if (!hash || hash === '#') return;
    const target = document.querySelector(hash);
    if (!target) return;

    const y = window.pageYOffset + target.getBoundingClientRect().top - getHeaderOffset();
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  // ① ページ内リンククリック（メニュー含む）をスムース化
  document.addEventListener('click', function (e) {
    const a = e.target.closest('a[href*="#"]');
    if (!a) return;

    const url = new URL(a.href, window.location.href);
    // 同一ページだけ対象（別ページ遷移は邪魔しない）
    if (url.pathname !== window.location.pathname) return;

    const hash = url.hash;
    if (!hash) return;

    e.preventDefault();
    history.pushState(null, '', hash);
    scrollToHash(hash);
  });

  // ② 直アクセス / リロードで # が付いてる場合
  window.addEventListener('load', function () {
    if (location.hash) {
      // レイアウト確定後にずらしてスクロール
      setTimeout(() => scrollToHash(location.hash), 0);
    }
  });
})();





// eギフト
document.addEventListener('DOMContentLoaded', function () {
  function toggleEgiftMode() {
    const egiftInput = document.querySelector('.sns-gift-product-container input[value="eGift"]');
    const egiftCheckedLabel = document.querySelector('.sns-gift-product-container label[data-checked] input[value="eGift"]');

    const isEgiftSelected =
      (egiftInput && egiftInput.checked) ||
      !!egiftCheckedLabel;

    document.body.classList.toggle('is-egift-selected', isEgiftSelected);
  }

  // 初期表示
  toggleEgiftMode();

  // ラジオ変更時
  document.addEventListener('change', function (e) {
    if (e.target.matches('.sns-gift-product-container input[type="radio"]')) {
      toggleEgiftMode();
    }
  });

  // クリック時にも判定
  document.addEventListener('click', function (e) {
    if (e.target.closest('.sns-gift-product-container')) {
      setTimeout(toggleEgiftMode, 100);
    }
  });

  // All in gift側の再描画対策
  const observer = new MutationObserver(function () {
    toggleEgiftMode();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-checked', 'checked', 'class']
  });
});